// ADDED
import React from "react";
import { ProcessManagerMain } from "./roles/Process/ProcessManagerMain";
import { AssignedEmployeeMain } from "./roles/Employee/AssignedEmployeeMain";
import { useFilterManager } from "../../../hooks/useFilterManager";
import { FEATURES } from "../../../../config/features";

const EmployeeTransactionModule = ({ user, userAccess, showGeneralMessage }) => {
  const filterManager = useFilterManager(FEATURES.EMPLOYEE_FILTERS || []);

  const sharedProps = { user, userAccess, showGeneralMessage, filterManager };

  const hasProcessManagerAccess =
    userAccess?.isEmployeeTransactionAssignmentManager ||
    userAccess?.isEmployeeTransactionCompensationManager ||
    userAccess?.isEmployeeTransactionScheduleManager;

  const hasAssignedEmployeeAccess = userAccess?.isEmployeeTransactionAssignedEmployee;


  if (hasProcessManagerAccess) {
    return <ProcessManagerMain {...sharedProps} />;
  }

  if (hasAssignedEmployeeAccess) {
    return <AssignedEmployeeMain {...sharedProps} />;
  }

  return null;
};

export default EmployeeTransactionModule;